import type {
  SupplierSmsCodeSendParams,
  SupplierSmsLoginParams,
} from '../../api/CommonApi'

const MOBILE_PATTERN = /^1[3-9]\d{9}$/
const VISIBLE_ASCII_CODE_PATTERN = /^[\x21-\x7e]{6}$/

const hasControlCharacter = (value: string) =>
  Array.from(value).some((character) => {
    const codePoint = character.charCodeAt(0)
    return codePoint < 32 || codePoint === 127
  })

export const normalizeSupplierIdentity = (
  values: SupplierSmsCodeSendParams,
): SupplierSmsCodeSendParams => ({
  enterpriseName: values.enterpriseName.trim(),
  mobile: values.mobile.trim(),
})

export const normalizeSupplierLogin = (
  values: SupplierSmsLoginParams,
): SupplierSmsLoginParams => ({
  ...normalizeSupplierIdentity(values),
  code: values.code,
})

export const validateEnterpriseName = (value?: string) => {
  const normalizedValue = value?.trim() ?? ''
  if (!normalizedValue) {
    return '请输入供应商抬头'
  }
  if (normalizedValue.length > 200) {
    return '供应商抬头最多输入200个字符'
  }
  if (hasControlCharacter(normalizedValue)) {
    return '供应商抬头格式不正确'
  }
  return undefined
}

export const validateMobile = (value?: string) => {
  const normalizedValue = value?.trim() ?? ''
  if (!normalizedValue) {
    return '请输入手机号'
  }
  if (!MOBILE_PATTERN.test(normalizedValue)) {
    return '请输入正确的11位手机号'
  }
  return undefined
}

export const validateSmsCode = (value?: string) => {
  if (!value) {
    return '请输入短信验证码'
  }
  if (!VISIBLE_ASCII_CODE_PATTERN.test(value)) {
    return '请输入6位短信验证码'
  }
  return undefined
}

export const isSupplierIdentityValid = (
  values: Partial<SupplierSmsCodeSendParams>,
) =>
  !validateEnterpriseName(values.enterpriseName) &&
  !validateMobile(values.mobile)

export const isSupplierLoginValid = (values: Partial<SupplierSmsLoginParams>) =>
  isSupplierIdentityValid(values) && !validateSmsCode(values.code)
import type {
  SupplierSmsCodeSendParams,
  SupplierSmsLoginParams,
} from '../../api/CommonApi'

const MOBILE_PATTERN = /^1[3-9]\d{9}$/
const VISIBLE_ASCII_CODE_PATTERN = /^[\x21-\x7e]{6}$/

const hasControlCharacter = (value: string) =>
  Array.from(value).some((character) => {
    const codePoint = character.charCodeAt(0)
    return codePoint < 32 || codePoint === 127
  })

export const normalizeSupplierIdentity = (
  values: SupplierSmsCodeSendParams,
): SupplierSmsCodeSendParams => ({
  enterpriseName: values.enterpriseName.trim(),
  mobile: values.mobile.trim(),
})

export const normalizeSupplierLogin = (
  values: SupplierSmsLoginParams,
): SupplierSmsLoginParams => ({
  ...normalizeSupplierIdentity(values),
  code: values.code,
})

export const validateEnterpriseName = (value?: string) => {
  const normalizedValue = value?.trim() ?? ''
  if (!normalizedValue) {
    return '请输入供应商抬头'
  }
  if (normalizedValue.length > 200) {
    return '供应商抬头最多输入200个字符'
  }
  if (hasControlCharacter(normalizedValue)) {
    return '供应商抬头格式不正确'
  }
  return undefined
}

export const validateMobile = (value?: string) => {
  const normalizedValue = value?.trim() ?? ''
  if (!normalizedValue) {
    return '请输入手机号'
  }
  if (!MOBILE_PATTERN.test(normalizedValue)) {
    return '请输入正确的11位手机号'
  }
  return undefined
}

export const validateSmsCode = (value?: string) => {
  if (!value) {
    return '请输入短信验证码'
  }
  if (!VISIBLE_ASCII_CODE_PATTERN.test(value)) {
    return '请输入6位短信验证码'
  }
  return undefined
}

export const isSupplierIdentityValid = (
  values: Partial<SupplierSmsCodeSendParams>,
) =>
  !validateEnterpriseName(values.enterpriseName) &&
  !validateMobile(values.mobile)

export const isSupplierLoginValid = (values: Partial<SupplierSmsLoginParams>) =>
  isSupplierIdentityValid(values) && !validateSmsCode(values.code)
